import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template142: Aeropuertos de Seúl
// Contenido desde page (texts, canvasImages). Sin fallbacks.
const Template142 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const airportSticker = getCanvasImageUrl("airport-sticker");
	const logoImage = getCanvasImageUrl("logo");
	const intro = page?.texts?.[1]?.content;
	const tituloIncheon = page?.texts?.[2]?.content;
	const contenidoIncheon = page?.texts?.[3]?.content;
	const tituloGimpo = page?.texts?.[4]?.content;
	const contenidoGimpo = page?.texts?.[5]?.content;
	const sabiasQue = page?.texts?.[6]?.content;

	let actualHeaderColor = headerBackgroundColor || "#2E8B80";

	const box = {
		backgroundColor: "#caeae6",
		border: "3px solid #2E8B80",
		borderRadius: "16px",
		padding: "16px",
	};

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "8px",
		color: "#2E8B80",
		marginTop: 0,
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	const ul = {
		paddingLeft: 18,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: 13, color: "#444" }}>
					<Box component="p" sx={p}>
						{intro}
					</Box>
				</Box>
			)}

			<Box
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: "16px",
					position: "relative",
					marginTop: isSmallScreen ? "10px" : 0,
				}}
			>
				{(tituloIncheon || contenidoIncheon) && (
					<Box data-block-id="text-2" sx={{ ...box, position: "relative" }}>
						{tituloIncheon && (
							<Box component="h3" sx={h3}>
								{tituloIncheon}
							</Box>
						)}
						{contenidoIncheon && (
							<Box
								sx={{ fontSize: 13, color: "#444" }}
								dangerouslySetInnerHTML={{ __html: contenidoIncheon }}
							/>
						)}
						{airportSticker && (
							<img
								src={airportSticker}
								alt="Aeropuerto"
								style={{
									width: isSmallScreen ? 80 : 90,
									position: "absolute",
									bottom: -60,
									right: isSmallScreen ? -30 : 0,
								}}
							/>
						)}
					</Box>
				)}

				{(tituloGimpo || contenidoGimpo) && (
					<Box data-block-id="text-3" sx={box}>
						{tituloGimpo && (
							<Box component="h3" sx={h3}>
								{tituloGimpo}
							</Box>
						)}
						{contenidoGimpo && (
							<Box
								sx={{ fontSize: 13, color: "#444" }}
								dangerouslySetInnerHTML={{ __html: contenidoGimpo }}
							/>
						)}
					</Box>
				)}

				{sabiasQue && (
					<Box
						data-block-id="text-4"
						sx={{
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "12px",
							padding: "12px 14px",
							fontSize: 12,
							marginTop: "4px",
						}}
						dangerouslySetInnerHTML={{ __html: sabiasQue }}
					/>
				)}
			</Box>
		</Box>
	);
};

Template142.thumbnail = "/images/template-1.png";

export default Template142;
